export function aggregate(...strs) {
    return strs.reduce((str, currStr) => {
        if (!currStr) {
            return str;
        }
        return str ? `${str} ${currStr}` : currStr;
    }, '');
}
//# sourceMappingURL=aggregate.js.map